import { Component, EventEmitter, Inject, Output } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { GlobalNotification } from '@models/notifications/notification.model';

@Component({
  selector: 'gc-notification-list',
  templateUrl: './notification-list.component.html',
  styleUrls: ['./notification-list.component.scss'],
  standalone: false,
})
export class NotificationListComponent {
  notifications: GlobalNotification[] = this.data.notifications;

  @Output() openDetail = new EventEmitter<GlobalNotification>();

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: { notifications: GlobalNotification[] },
    private readonly dialogRef: MatDialogRef<NotificationListComponent>,
  ) {}

  onSelect(notification: GlobalNotification) {
    this.openDetail.emit(notification);
  }
  close() {
    this.dialogRef.close();
  }
}
